<div class="header">
  <spb-logo title="Omsättningsverktyg"></spb-logo>
  <div class="filler"></div>
  <spb-toggle-button></spb-toggle-button>

  @if (configService.currentUser()) {
    <div class="name">
      {{ configService.currentUser()?.name }}
      @if (configService.isAdmin()) {
        <button
          [style.margin-right.px]="4"
          [matMenuTriggerFor]="menu" mat-icon-button>
          <mat-icon>menu</mat-icon>
        </button>
      }
    </div>

    <mat-menu #menu="matMenu">
      <button
        [routerLink]="['landing']" mat-menu-item
        routerLinkActive="selected">
        Startsidan
      </button>
      <button [routerLink]="['main', 'list']" mat-menu-item
              routerLinkActive="selected">
        Översiktsvy
      </button>
      <button [routerLink]="['discount']" mat-menu-item
              routerLinkActive="selected">Ränteerbjudande
      </button>
      <button
        [routerLink]="['bindings']" mat-menu-item
        routerLinkActive="selected">
        Nya villkor
      </button>
      <button (click)="preBound()"
              mat-menu-item>Villkorsbilaga
      </button>
      @if (roles.kundcenter()) {
        <button [routerLink]="['ondemand']" mat-menu-item
                routerLinkActive="selected">Skriv ut
        </button>
      }
      <button (click)="filterService.resetFilter()" mat-menu-item>Återställ
        filter
      </button>
      <mat-divider></mat-divider>
      <button (click)="configService.reset()" mat-menu-item>Logga ut</button>
    </mat-menu>
  }
</div>
